import { getUniqueId } from '../../../helpers';
import { ShapeType } from '../types';

export const generateShapeId = (type: ShapeType, suffix?: string): string => {
  const uuid = getUniqueId();
  return `${type}${suffix ? `-${suffix}` : ''}-${uuid}`;
};
